import * as React from 'react';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import CheckIcon from '@mui/icons-material/CheckCircleOutline';
import InfoIcon from '@mui/icons-material/InfoOutlined';
import { Stack } from '@mui/material';
import { CustomDialog } from './styles';
import Button from '../button';

const icons = {
  SUCCESS: <CheckIcon fontSize="large" sx={{ color: 'Feedback/Sucess' }} />,
  INFO: <InfoIcon fontSize="large" sx={{ color: 'Feedback/Info' }} />,
  ERROR: <InfoIcon fontSize="large" sx={{ color: 'Feedback/Erro' }} />,
};

export type PopupVariants = 'SUCCESS' | 'INFO' | 'ERROR';

export interface PopupProps {
  id?: string;
  open: boolean;
  text: string;
  variant?: PopupVariants;
  customIcon?: React.ReactNode;
  children?: React.ReactNode;
  onClose: () => void;
  onPressOk?: () => void;
}

export default function Popup({
  id,
  open,
  text,
  variant = 'INFO',
  onClose,
  onPressOk,
  children,
  customIcon,
}: PopupProps) {
  return (
    <CustomDialog
      onClose={onClose}
      open={open}
      variant={variant}
      PaperProps={{ className: variant }}
    >
      <DialogContent id={id}>
        <Stack alignItems="center">
          {customIcon ? customIcon : icons[variant]}

          <Typography
            mt={1.5}
            mb={2}
            textAlign="center"
            variant="Headlines/Medium"
            color="Black-White/Black"
          >
            {text}
          </Typography>

          {children ? (
            children
          ) : (
            <Button
              variant="contained"
              onClick={onPressOk}
              sx={{ width: '100%' }}
              id="popup-botao-entendi"
            >
              <Typography variant="Headlines/Small" textTransform="initial">
                Entendi
              </Typography>
            </Button>
          )}
        </Stack>
      </DialogContent>
    </CustomDialog>
  );
}
